import { WarningOutlined } from "@ant-design/icons";
import { TimePicker as AntdTimePicker } from "antd";
import cx from "classnames";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useField } from "formik";

import styles from "./TimePicker.module.css";
import { type } from "@testing-library/user-event/dist/type";
import moment from "moment";
import { useTranslation } from "react-i18next";
import locale from "antd/es/date-picker/locale/de_DE";

dayjs.extend(customParseFormat);

function TimePicker({
  required = false,
  className = "",
  name = "",
  label = "",
  size = "middle",
  disabled = false,
  suffeicon = false,
  format = "HH:mm:ss",
  onChange = () => { },
  mindate = null,
  maxdate = null,
  readOnly = false
}) {
  const { i18n } = useTranslation();
  const [field, meta, helpers] = useField(name);
  const { value, error, touched } = meta;
  const { setValue } = helpers;

  const handleChange = (_, timeString) => {
    if (!timeString) {
      const toEmpty = "00:00:00";
      setValue(toEmpty);
      onChange(toEmpty);
    } else {
      setValue(timeString);
      onChange(timeString);
    }
  };

  const disabledHours = () => {
    if (mindate?.hour) {
      const hours = mindate.get("h");
      return Array.from(new Array(hours), (_, index) => index);
    } else {
      return []
    }
  };
  const disabledHoursMax = () => {
    if (maxdate?.hour) {
      const hours = mindate.get("h");
      return Array.from(new Array(hours), (_, index) => index);
    } else {
      return []
    }
  };

  const disabledMinutes = (selectedHour) => {
    if (mindate) {
      const minutes = mindate.get("m");
      if (selectedHour > moment().hours()) {
        return Array.from(new Array(minutes), (_, index) => index);
      }
    }
    return [];
  };

  const disabledSeconds = (selectedHour, selectedMinute) => {
    if (mindate) {
      const seconds = mindate.get("s");
      if (selectedHour === moment().hours() && selectedMinute === moment().minutes()) {
        return Array.from(new Array(seconds), (_, index) => index);
      }
    }
    return [];
  };

  return (
    <div className={cx(styles.container, className)}>
      {label && (
        <label className={cx("label", styles.label)} htmlFor={name}>
          {label}
          {required && <span className="error">*</span>}
        </label>
      )}
      <AntdTimePicker
        id={name}
        name={name}
        value={dayjs(value, format)}
        defaultValue={dayjs("00:00:00", format)}
        format={format}
        onChange={handleChange}
        needConfirm={false}
        minuteStep={1}
        secondStep={60}
        readOnly={readOnly}
        locale={{
          ...locale,
          lang: {
            ...locale.lang,
            now: (i18n.language === "en" ? "Now" : "เวลานี้"),
          }
        }}
        // showNow={false}
        // onOk={handleChange}
        // onBlur={handleBlur}
        disabledTime={() => ({
          disabledHours,
          disabledMinutes,
          disabledSeconds,
        })}
        // minDate={dayjs("09:00:00", "HH:mm:ss")}
        data-state={touched && error ? "error" : ""}
        status={touched && error ? "error" : ""}
        disabled={disabled}
        size={size}
        {...(suffeicon ? { suffixIcon: null } : {})}
      />
      {touched && error && (
        <span className={cx("error", styles.error)}>
          <WarningOutlined /> {error}
        </span>
      )}
    </div>
  );
}

export default TimePicker;
